<footer class="main-footer">
    <strong>SmartWatchDashboard</strong>
    
    <div class="float-right d-none d-sm-inline-block">
      <b>Version</b> 1.0.0
    </div>
  </footer>